export * from "./google-tag-manager-service";
